
import {merge as observableMerge,  BehaviorSubject ,  Observable } from 'rxjs';

import {map} from 'rxjs/operators';
import { PacketQueueCategory, CreatePackageDialogComponent } from './../create-package-dialog/create-package-dialog.component';
import { ConfigurationService } from './../../shared/configuration.service';
import { PacketDetails } from './../../shared/configuration.model';
import { Logger } from './../../shared/logger.service';
import { Dialog } from './../../shared/dialog.model';
import { ConfirmdialogComponent } from './../../dialogs/confirmdialog/confirmdialog.component';
import { AuthenticationService } from './../../shared/authentication.service';
import { SuspendedTicket } from './../../shared/qualityticketqueue.model';
import { QualityTicketService } from './../../shared/qualityticketqueue.service';
import { Component, ElementRef, ViewChild, OnInit, forwardRef, ChangeDetectorRef } from '@angular/core';
import { DataSource, SelectionModel } from '@angular/cdk/collections';
import { MatPaginator, MatSort, MatTable, MatDialog } from '@angular/material';
import { MatSnackBar } from  '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../shared/user';






import { resolve } from 'url';


@Component({
  selector: 'app-view-package',
  templateUrl: './package-list.component.html',
  styleUrls: ['./package-list.component.scss']
})
export class PackageListComponent implements OnInit {
  screen = false;
  isUnlockDisabled = false;
  isDataAvailable = true;
  role: string;
  displayedColumns = ['PacketName', 'PacketType', 'PacketQueueCategory', 'Creation', 'Status', 'Reset', 'Edit'];
  dataChange: BehaviorSubject<PacketDetails[]> = new BehaviorSubject<PacketDetails[]>([]);
  get data(): PacketDetails[] { return this.dataChange.value; }
  dataSource: PacketDataSource | null;
  title: string;
  content: string;
  UpdatePacket: PacketDetails | null;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filter: ElementRef;

  updateLockRow: SuspendedTicket[] = [];
  private category: string;

  constructor(
    public dialog: MatDialog,
    private service: ConfigurationService,
    private cdRef: ChangeDetectorRef,
    private auth: AuthenticationService,
    public router: Router,
    public route: ActivatedRoute,
    public snackBar: MatSnackBar,
    public logger: Logger,
    public authService: AuthenticationService) {
  }
  populatePackets() {
    
    this.service.getPackages(this.auth.currentState).subscribe(res => {
      res.forEach(element => {
        if (element.IsActive) {
          element.Status = 'Active';
        }
        else {
          element.Status = 'InActive';
        }
      });
      this.dataChange.next(res);
      this.isDataAvailable = true;
      this.cdRef.detectChanges();
      this.initSource();
    });
  }

  ngOnInit() {
    
    this.populatePackets();
  }

  initSource() {
    this.dataSource = new PacketDataSource(this, this.sort);
  }

  InActivatePacket(packetId: number) {
    let infoDialog = this.dialog.open(ConfirmdialogComponent, {
      width: '400px',
      data: {
        title: 'Alert',
        content: 'Are you sure, You want to InActivate the Packet?'
      }
    });

    infoDialog.afterClosed().subscribe(result => {
      if (result !== 'Cancel') {
        this.service.inActivatePacket(packetId, this.auth.currentState).subscribe(res => {
          this.service.getPackages(this.auth.currentState).subscribe(items => {
          items.forEach(element => {
            if (element.IsActive) {
              element.Status = 'Active';
            }
            else {
              element.Status = 'InActive';
            }
          });
          this.dataChange.next(items);
          this.isDataAvailable = true;
          this.cdRef.detectChanges();
          this.initSource();
        });
      });
      }else {
        this.screen = false;
      }
    });
  }

  ResetPacket(packetId: number){
    let infoDialog = this.dialog.open(ConfirmdialogComponent, {
      width: '400px',
      data: {
        title: 'Alert',
        content: 'Are you sure, You want to Reset the Packet?'
      }
    });

    infoDialog.afterClosed().subscribe(result => {
      this.screen = true;
      if (result !== 'Cancel') {
        this.service.resetPacket(packetId, this.auth.currentState).subscribe(res => {
          this.service.getPackages(this.auth.currentState).subscribe(items => {
          items.forEach(element => {
            if (element.IsActive) {
              element.Status = 'Active';
            }
            else {
              element.Status = 'InActive';
            }
          });
          this.dataChange.next(items);
          this.isDataAvailable = true;
          this.cdRef.detectChanges();
          this.screen = false;
          this.initSource();
        });
      });
      }else {
        this.screen = false;
      }
    });
  }
  EditPacket(packet: PacketDetails){
    let dialogRef = this.dialog.open(CreatePackageDialogComponent, {
      width: '600px',
      data: packet
    });

    dialogRef.afterClosed().subscribe(result => {
      this.screen = true;
      if (result === 'Cancel') {
        this.screen = false;
      }
      else {
        this.service.editPacket(packet.ID, result.packageName, result.priority, this.auth.currentState).subscribe(res =>{
          this.service.getPackages(this.auth.currentState).subscribe(items => {
            items.forEach(element => {
              if (element.IsActive) {
                element.Status = 'Active';
              }
              else {
                element.Status = 'InActive';
              }
            });
            this.dataChange.next(items);
            this.isDataAvailable = true;
            this.screen = false;
            this.cdRef.detectChanges();
            this.initSource();
          });
        });
      }
    })
  }
}

export class PacketDataSource extends DataSource<any> {

  constructor(private rcgcomponent: PackageListComponent,
    private _sort: MatSort) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<PacketDetails[]> {
    // Listen for any changes in the base data, sorting, filtering, or pagination
    const displayDataChanges = [
      this.rcgcomponent.dataChange,
      this._sort.sortChange,
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      return this.sortData();
    }));
  }

  disconnect() { }

  /** Returns a sorted copy of the database data. */
  sortData(): PacketDetails[] {
    const data = this.rcgcomponent.data.slice();
    if (!this._sort.active || this._sort.direction == '') { return data; }

    return data.sort((a, b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'PacketName': [propertyA, propertyB] = [a.Name, b.Name]; break;
        case 'PacketQueueCategory': [propertyA, propertyB] = [a.QueueCategory, b.QueueCategory]; break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }
}
